import "./style.less";
import BasketToCheckout from "./factory";
import basket from "./directive";
import BasketAside from "./basket-aside";
import basketBooking from "./basket-booking";
import basketHeader from "./basket-header";
import BasketPrice from "./basket-price";
import repeatableBookingDirectives from "./repeatable-bookings";

import basketConditionsModal from "./basket-condition-modal/module";

const modul = angular
    .module("basketDirectives", [
        repeatableBookingDirectives,
        basketConditionsModal,
    ])

    .factory("BasketToCheckout", BasketToCheckout)
    .directive("basket", basket)
    .directive("basketAside", BasketAside)
    .directive("basketBooking", basketBooking)
    .directive("basketHeader", basketHeader)
    .directive("basketPrice", BasketPrice);

export default modul.name;
